import script from "./ImageUploader.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageUploader.vue?vue&type=script&setup=true&lang=js"

import "./ImageUploader.vue?vue&type=style&index=0&id=22b395e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22b395e8"]])

export default __exports__